








import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {

  },
})
export default class ToggleButton extends Vue {
  @Prop({required: true})
  public dirty?: boolean;
  @Prop({required: true})
  public saving?: boolean;
}
